import { PayoutType } from './payout.type';



export const setMoneyTransferTotalAmount = (data) => ({
    type: PayoutType.setMoneyTransferTotalAmount,
    payload: data
    
  });
  export const setMoneyTransferSurChargeAmount = (data) => ({
    type: PayoutType.setMoneyTransferSurChargeAmount,
    payload: data
    
  });
  export const showCreateOrderResponse = (data) => ({
    type: PayoutType.showCreateOrderResponse,
    payload: data
    
  });
  export const setOrderId = (data) => ({
    type: PayoutType.setOrderId,
    payload: data
    
  });
  export const setAmount = (data) => ({
    type: PayoutType.setAmount,
    payload: data
    
  });


export const setTxnAmount = (data) => ({
  type: PayoutType.setTxnAmount,
  payload: data
  
});

export const setTxnsurcharge = (data) => ({
  type: PayoutType.setTxnsurcharge,
  payload: data
  
});

export const setTxntotalAmount = (data) => ({
  type: PayoutType.setTxntotalAmoun,
  payload: data
  
});

  
export const setMoneyTransferProgress = (data) => ({
  type: PayoutType.setMoneyTransferProgress,
  payload: data
  
});

export const setCreteOrderReq= (data) => ({
  type: PayoutType.setCreteOrderReq,
  payload: data
  
});

export const setCreateOrderRes= (data) => ({
  type: PayoutType.setCreateOrderRes,
  payload: data
  
});
export const setStatusEnqResponse= (data) => ({
  type: PayoutType.setStatusEnqResponse,
  payload: data
  
});

export const setMerchantDetails = (data) => ({
  type: PayoutType.setMerchantDetails,
  payload: data
  
});

export const setFilterStartDate = (data) => ({
  type: PayoutType.setFilterStartDate,
  payload: data
  
});
export const setFilterEndDate = (data) => ({
  type: PayoutType.setFilterEndDate,
  payload: data
  
});

  export const resetPayoutType ={
    type: PayoutType.RESET
  }

